<script setup lang="ts">
</script>
<template>
    <svg width="100%" height="100%" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5399e-08 7L13.5 0.0717966L13.5 13.9282L9.5399e-08 7Z" fill="#F05A42"/>
    </svg>
</template>

    